export interface Voucher {
    voucherId: number;
    code: string;
    type: string;
    amount: number;
    cap: number;
    claims: number;
    limit: number;
    cityIds: number[];
    isActive: boolean;
  }
  
  export enum VoucherType {
    Credits = 1,
    DiscountFixed = 2,
    DiscountCap = 3
  }
  
  export interface CreateVoucherData {
    code: string;
    type: number;
    amount: number;
    cap: number;
    limit: number;
    isActive: boolean;
  }